<template />
<script lang="ts">
import { defineComponent } from 'vue'

import { ElNotification } from 'element-plus'

export default defineComponent({
  name: 'ServiceWorkerUpdatePopup',
  data() {
    return {
      refreshing: false,
      notificationText: 'New content is available!',
      refreshButtonText: 'Refresh',
      registration: null as ServiceWorkerRegistration | null,
    }
  },
  created() {
    // Listen for swUpdated event and display refresh notification as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  },
  methods: {
    render() {},
    showRefreshUI(e: Event) {
      // Display a notification inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      // @ts-expect-error - Vue 2 legacy API ($createElement), component is deprecated but kept for backward compatibility
      const h = this.$createElement
      this.registration = (e as CustomEvent).detail as ServiceWorkerRegistration
      ElNotification({
        title: 'Update available',
        message: h('div', { class: 'sw-update-popup' }, [
          this.notificationText,
          h('br'),
          h(
            'el-button',
            {
              attrs: {
                type: 'info',
              },
              on: {
                click: (e: Event) => {
                  e.preventDefault()
                  this.refreshApp()
                },
              },
            },
            this.refreshButtonText,
          ),
        ]),
        position: 'bottom-right',
        duration: 0,
      })
    },
    refreshApp() {
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) return
      this.registration.waiting.postMessage('skipWaiting')
    },
  },
})
</script>

<style lang="scss" scoped>
.sw-update-popup > button {
  margin-top: 0.5em;
  padding: 0.25em 1.5em;
}
</style>
